const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/gamification/achievements/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/gamification/achievements/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "New Achievement",
      description: "Page title for the new achievement path"
    })
  }
});